import { STANDARD_DUEL_RULES, type DuelRules } from "@mk/shared";
import { messages } from "../../i18n/index.ts";

export function standardDuelRules(): DuelRules {
  return { ...STANDARD_DUEL_RULES };
}

/**
 * Kurallar standarttan farklı mı?
 *
 * Canlı düello başlığındaki kural satırı buna bakıyor: standart maçta o satır
 * hiçbir şey anlatmıyor ama dikey alandan yiyor — tahta da o kadar küçülüyor.
 */
export function isStandardDuelRules(rules: DuelRules): boolean {
  return (
    rules.durationMinutes === STANDARD_DUEL_RULES.durationMinutes &&
    rules.maxAttempts === STANDARD_DUEL_RULES.maxAttempts &&
    rules.victoryRule === STANDARD_DUEL_RULES.victoryRule &&
    rules.pressureEnabled === STANDARD_DUEL_RULES.pressureEnabled
  );
}

export function victoryRuleLabel(rule: DuelRules["victoryRule"]): string {
  return rule === "first-to-solve" ? messages.duel.firstWins : messages.duel.fewestWins;
}

export function duelRulesSummary(rules: DuelRules): string {
  const parts = [
    messages.duel.minutes(rules.durationMinutes),
    messages.duel.attempts(rules.maxAttempts),
    victoryRuleLabel(rules.victoryRule),
  ];
  if (rules.victoryRule === "fewest-attempts") {
    parts.push(rules.pressureEnabled ? messages.duel.pressureOn : messages.duel.pressureOff);
  }
  return parts.join(" · ");
}
